<template>
  <div>
    <v-overlay :value="overlay" opacity="0.11">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="editDialog" max-width="350">
      <v-card>
        <v-card-title>
          <span class="headline">Editer Sexe</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-radio-group v-model="editedItem.sexe" row>
                    <v-radio label="Masculin" :value="parseInt(1)"></v-radio>
                    <v-radio label="Féminin" :value="parseInt(0)"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="info" @click.native="closeDialog()"
            >Annuler</v-btn
          >
          <v-btn rounded color="primary" @click.native="updateMembre()"
            >Mettre à jour</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--  {{ detailEtape.type_champ }} -->
    <div v-if="membre.sexe !== 1 || membre.sexe !== 0">
      <div v-if="detailEtape.type_champ == 0">
        <v-checkbox
          v-model="valueCheckbox"
          @change="createFiche()"
        ></v-checkbox>
      </div>
      <div v-else-if="detailEtape.type_champ == 1">
        <v-text-field
          v-model="valueChiffre"
          type="number"
          dense
          solo
          :rules="requis"
          required
        />
        <v-btn :loading="loading" fab color="success" @click="createFiche()"
          ><v-icon>mdi-content-save</v-icon></v-btn
        >
      </div>
      <div v-else-if="detailEtape.type_champ == 2">
        <v-text-field
          :loading="loading"
          v-model="valueAlpnanumerique"
          dense
          solo
          type="text"
          :rules="requis"
          required
        />
        <v-btn :loading="loading" fab color="success" @click="createFiche()"
          ><v-icon>mdi-content-save</v-icon></v-btn
        >
      </div>
      <div v-else-if="detailEtape.type_champ == 3">
        <v-text-field
          v-model="valueDate"
          dense
          solo
          label="Date"
          type="date"
          :rules="requis"
          required
        />

        <v-btn :loading="loading" fab color="success" @click="createFiche()"
          ><v-icon>mdi-content-save</v-icon></v-btn
        >
      </div>
    </div>
    <div v-else>
      <v-btn
        color="grey lighten-2 mr-4"
        fab
        class="elevation-0"
        @click="showEditDialog(membre)"
      >
        <v-icon>mdi-account-edit-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.getFiche();
  },
  data() {
    return {
      overlay: false,
      fiche: null,
      valueAlpnanumerique: "",
      valueChiffre: "",
      valueCheckbox: "",
      valueDate: "",
      loading: false,
      isNewFiche: false,
      requis: [(v) => !!v || "Ne doit pas être vide"],
      editDialog: false,
      editedItem: {},
    };
  },
  props: {
    membre: {
      required: true,
    },
    detailEtape: {
      required: true,
    },
    etapeEffective: {
      required: true,
    },
  },
  methods: {
    showEditDialog(item) {
      this.editDialog = true;
      this.editedItem = item;
    },
    closeDialog() {
      this.editDialog = false;
    },

    updateMembre() {
      const self = this;
      var luser = {
        sexe: this.editedItem.sexe,
      };

      console.log(luser);

      var ref = this.$firebase
        .firestore()
        .collection("membres")
        .doc(this.editedItem.id);
      ref
        .set(luser, { merge: true })
        .then(function () {
          console.log("membre successfully updated!");
          var objet = { userId: self.editedItem.id, data: luser };
          self.UpdateMembreDansAutresCollections(objet);
          self.code_menage_selected = false;
          self.editDialog = false;
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
        })
        .catch(function (error) {
          console.error("Error updating document: ", error);
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
          self.GetMembresDuGroupeInactifs(self.editedItem.id_groupe);

          self.editDialog = false;
        });
    },
    initCompute(sexe, value, action, detailEtape) {
      var dataTosend = { sexe, value, action, detailEtape };
      this.$emit("initCompute", dataTosend);
    },
    getFiche() {
      let self = this;
      console.log("nandalo teto", self.detailEtape.id);
      let elems = [];
      self.overlay = true;

      this.$firebase
        .firestore()
        .collection("fiches")
        .where("membres_id_membre", "==", self.membre.id)
        .where(
          "etape_effective_id_etape_effective",
          "==",
          self.etapeEffective.id
        )
        .where("details_etapes_id_details_etape", "==", self.detailEtape.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          if (elems.length === 0) {
            console.log("halavany", elems.length);
            self.isNewFiche = true;
          } else {
            self.isNewFiche = false;
          }
          console.log("isNewfiche from base", self.isNewFiche);
          console.log("valiny", elems);
          self.fiche = elems[0];
          self.valueAlpnanumerique = elems[0].valeur;
          self.valueChiffre = elems[0].valeur;
          self.valueCheckbox = elems[0].valeur;
          self.valueDate = elems[0].valeur;
          self.overlay = false;
        })
        .catch((error) => {
          console.log("get Fiche Error getting documents: ", error);
          self.overlay = false;
        });
    },

    createFiche() {
      console.log("NewFiche", this.isNewFiche);
      this.loading = true;
      let self = this;
      let val = "vide";
      if (this.detailEtape.type_champ == 0) {
        console.log("valueCheckbox", this.valueCheckbox);
        val = this.valueCheckbox;
        console.log("val0*****************----->", val);
      } else if (this.detailEtape.type_champ == 1) {
        val = this.valueChiffre;
        console.log("val1*****************----->", val);
      } else if (this.detailEtape.type_champ == 2) {
        val = this.valueAlpnanumerique;
        console.log("val2*****************----->", val);
      } else if (this.detailEtape.type_champ == 3) {
        val = this.valueDate;
        console.log("val30*****************----->", val);
      }
      // insert new Fiche
      if (this.isNewFiche && val !== "vide") {
        console.log("val???*****************----->", val);
        console.log("Membre", self.membre.id);
        console.log("etapeEffective", self.etapeEffective.id);
        console.log("detailEtape", self.detailEtape.id);

        let uuidFiche = this.$uuid.v4();
        let newFiche = {
          idFiche: uuidFiche,
          membres_id_membre: self.membre.id,
          etape_effective_id_etape_effective: self.etapeEffective.id,
          details_etapes_id_details_etape: self.detailEtape.id,
          valeur: val,
          date_fiche: Date.now(),
          groupes_id_groupe: self.etapeEffective.groupes_id_groupe,
          parcours_id_parcours: self.etapeEffective.parcours_id_parcours,
          ll_parcours: self.etapeEffective.ll_parcours,
          programmes_id_programme: self.etapeEffective.programmes_id_programme,
          abbr_parcours: self.etapeEffective.abbr_parcours,
          description_parcours: self.etapeEffective.description_parcours,
          ll_fokontany: self.membre.ll_fokontany,
          id_commune: self.membre.id_commune,
          ll_commune: self.membre.ll_commune,
          id_district: self.membre.id_district,
          ll_district: self.membre.ll_district,
          id_region: self.membre.id_region,
          ll_region: self.membre.ll_region,
          nom_responsable: self.membre.nom_responsable,
          longitude: self.etapeEffective.longitude,
          latitude: self.etapeEffective.latitude,
          id_responsable: self.etapeEffective.id_responsable,
          ll_parcours_effectif: self.etapeEffective.ll_parcours_effectif,
          ll_programme: self.etapeEffective.ll_programme,
          themes_id_theme: self.etapeEffective.themes_id_theme,
          ll_theme: self.etapeEffective.ll_theme,
          id_bailleur: self.etapeEffective.id_bailleur,
          ll_bailleur: self.etapeEffective.ll_bailleur,
          abbr_bailleur: self.etapeEffective.abbr_bailleur,
          parcours_effectif_id_parcours_effectif:
            self.etapeEffective.parcours_effectif_id_parcours_effectif,
          etape_id_etape: self.detailEtape.etape_id_etape,
          date_insert_etape_effective:
            self.etapeEffective.date_insert_etape_effective,
          ll_etape: self.etapeEffective.ll_etape,
          rang: self.etapeEffective.rang,
          nom_groupe: self.membre.nom_groupe,
          village: self.membre.village,
          code_fokontany: self.membre.code_fokontany,
          nom: self.membre.nom,
          sexe: self.membre.sexe,
          annee_naissance: self.membre.annee_naissance,
          membre_gec: self.membre.membre_gec,
          ll_details_etapes: self.detailEtape.ll_details_etapes,
          type_champ: self.detailEtape.type_champ,
        };
        if (self.etapeEffective.ll_mois) {
          //start
          newFiche.date_debut = self.etapeEffective.date_debut;
          newFiche.date_fin = self.etapeEffective.date_fin;
          newFiche.ll_mois = self.etapeEffective.ll_mois;
          //end
        }

        console.log(newFiche);
        this.$firebase
          .firestore()
          .collection("fiches")
          .doc(uuidFiche)
          .set(newFiche, { merge: true })
          .then(() => {
            console.log("Fiche successfully written!");
            self.getFiche();
            self.loading = false;
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
        //insertToVuex
        this.addOneItem(newFiche);
        self.initCompute(
          newFiche.sexe,
          newFiche.valeur,
          "add",
          self.detailEtape
        );
      } else {
        console.log("newFiche", this.isNewFiche);
        console.log("ato ve????", val);
        // Edition
        if (val === false) {
          console.log("Valeur false");
          if (self.fiche) {
            console.log("supprimer ?", self.fiche.id);
            self.deleteFiche(self.fiche);
          }
        } else if (val !== "vide") {
          self.loading = true;
          var ficheRef = this.$firebase
            .firestore()
            .collection("fiches")
            .doc(self.fiche.id);

          ficheRef
            .set(
              {
                valeur: val,
              },
              { merge: true }
            )
            .then(() => {
              console.log("Fiche successfully Modifieddd!");
              self.getFiche();
              self.initCompute(
                self.fiche.sexe,
                val,
                "modify",
                self.detailEtape
              );
              self.loading = false;
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          console.log("Valeur vide");
          if (self.fiche) {
            console.log("supprimer ?", self.fiche.id);
            self.deleteFiche(self.fiche);
          }
        }

        self.loading = false;
      }
    },
    deleteFiche(fiche) {
      let self = this;
      console.log("Fiche to delete : ", fiche.id);
      this.$firebase
        .firestore()
        .collection("fiches")
        .doc(fiche.id)
        .delete()
        .then(function () {
          console.log("Fiche successfully deleted!");
          self.loading = false;
          self.initCompute(
            fiche.sexe,
            fiche.valeur,
            "delete",
            self.detailEtape
          );
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
          self.loading = false;
        });
    },
    ...mapActions({
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      addOneItem: "Fiches/addOneItem",
      startBusyState: "Loading/startBusyState",
      stopBusyState: "Loading/stopBusyState",
      UpdateMembreDansAutresCollections:
        "Membres/UpdateMembreDansAutresCollections",
      GetMembresDuGroupeInactifs: "Membres/GetMembresDuGroupeInactifs",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
